import { HOT_RANK } from "@/mocks/gua";

export default function HotRank() {
  return (
    <section id="hot" className="w-full bg-[#faf6ef]">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-rose-500">热度榜单 · 每 10 分钟刷新</p>
            <h2 className="mt-1.5 flex items-center gap-2 text-2xl font-extrabold text-stone-900 md:text-3xl">
              热门前排围观
              <i className="ri-fire-fill text-rose-500" />
            </h2>
            <p className="mt-2 text-sm text-stone-500">当前全网都在看的大事件，按围观热度排座次。</p>
          </div>
          <div className="flex items-center gap-2 whitespace-nowrap text-xs text-stone-400">
            <i className="ri-timer-line text-rose-500" />
            热度区间 580万 – 1280万
          </div>
        </div>

        <div className="mt-6 grid gap-3 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
          {HOT_RANK.map((item) => {
            const top3 = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#scene"
                className="group relative flex items-start gap-4 overflow-hidden rounded-lg border border-stone-200/70 bg-white p-4 transition hover:border-rose-200 hover:bg-rose-50/30 md:p-5"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-lg text-base font-extrabold ${
                    top3 ? "bg-rose-500 text-white" : "bg-orange-100 text-orange-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-md bg-stone-100 px-2 py-0.5 text-[11px] font-semibold text-stone-600">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-[11px] font-bold text-rose-500">
                      <i className="ri-fire-line" />
                      {item.heat}
                    </span>
                  </div>
                  <h3 className="mt-1.5 whitespace-nowrap text-sm font-bold text-stone-800 transition group-hover:text-rose-600">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-stone-500">{item.summary}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}